export default {
    data() {
      return {
        refreshing: false,
        registration: null,
        updateExists: false,
      };
    },
  
    created() {
      // Escuchar el evento personalizado del SW para actualizar cuando haya uno nuevo
      document.addEventListener('swUpdated', this.updateAvailable, { once: true });
  
      // Prevenir múltiples refrescos de la página
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        // Recargar la página cuando el Service Worker esté activado
        window.location.reload();
      });
    },
  
    methods: {
      // Maneja cuando una actualización está disponible
      updateAvailable(event) {
        this.registration = event.detail;
        this.updateExists = true;
  
        // Llama automáticamente a la actualización en cuanto esté lista
        this.autoRefreshApp();
      },
  
      // Este método se llama automáticamente para refrescar la app sin intervención del usuario
      autoRefreshApp() {
        this.updateExists = false;
  
        // Asegurarse de que el SW está esperando para aplicar la actualización
        if (this.registration && this.registration.waiting) {
          // Envía el mensaje al SW para que salte la espera
          this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }
    }
  };
  